var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _ReactModal from 'react-modal';
import { importedDefaultComponentShim } from '../../../utils/misc';
import { ThemeProvider, useTheme, } from '../../../theme';
import { GROUP_TYPE, Group } from '../../elements/Group';
import { Row } from '../../elements/layout/Row';
import { HEADING_SIZE, Heading } from '../../elements/Heading';
import { BUTTON_TYPE, Button } from '../../elements/Button';
import { COLOR } from '../../../theme/colors';
import { TYPOGRAPHY_TYPE } from '../../../theme/typography';
import { useMediaQuery } from '../../providers/media';
import { useComponentConfig } from '../../providers/componentConfig';
const ReactModal = importedDefaultComponentShim(_ReactModal);
export const Modal = (_a) => {
    var _b;
    var { children, heading, hideHeading, isOpen, footer, actions, wrapWithTheme, close, zIndex, bodyStyles } = _a, props = __rest(_a, ["children", "heading", "hideHeading", "isOpen", "footer", "actions", "wrapWithTheme", "close", "zIndex", "bodyStyles"]);
    const { breakpoint } = useMediaQuery();
    const { modal } = useComponentConfig();
    const theme = useTheme();
    const shouldShowFooter = footer !== undefined || (actions !== undefined && actions.length > 0);
    const modalBody = (_jsxs(Group, Object.assign({ type: GROUP_TYPE.REGION, sx: { my: 0 } }, { children: [!hideHeading && (_jsxs(Row, Object.assign({ justify: "space-between", align: "center", sx: {
                    p: 3,
                    borderBottom: 'solid 1px',
                    borderColor: COLOR.LIGHT_GRAY,
                } }, { children: [_jsx(Heading, Object.assign({ size: HEADING_SIZE.SM, typography: TYPOGRAPHY_TYPE.CONTROL_MEDIUM, sx: { mt: 0 } }, { children: heading })), _jsx(Button, Object.assign({ type: BUTTON_TYPE.TEXT, onClick: (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            close(e);
                        } }, { children: "Close" }))] }))), _jsx(Row, Object.assign({ sx: Object.assign({ p: 3 }, bodyStyles) }, { children: children })), shouldShowFooter && (_jsxs(Row, Object.assign({ sx: { borderTop: 'solid 1px', borderColor: COLOR.LIGHT_GRAY, p: 3 } }, { children: [footer, actions !== undefined && (_jsx(Row, Object.assign({ sx: { width: '100%', justifyContent: 'flex-end' } }, { children: actions.map((action, index) => (_jsx(Button, Object.assign({ type: action.isPrimary ? BUTTON_TYPE.DEFAULT : BUTTON_TYPE.OUTLINE, onClick: (e) => {
                                action.onClick(e);
                            }, sx: {
                                mr: index < actions.length - 1 ? 1 : 0,
                            } }, action.buttonProps, { children: action.label }), index))) })))] })))] })));
    return (_jsx(ReactModal, Object.assign({ isOpen: isOpen, shouldFocusAfterRender: true, appElement: modal.appElement, onRequestClose: (e) => {
            e.preventDefault();
            e.stopPropagation();
            close(e);
        } }, props, { style: {
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: zIndex || ((_b = theme.zIndex) === null || _b === void 0 ? void 0 : _b.MODAL),
            },
            content: {
                padding: 0,
                minWidth: breakpoint === 0 ? 'calc(100% - 1rem)' : '500px',
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
            },
        } }, { children: wrapWithTheme ? _jsx(ThemeProvider, { children: modalBody }) : modalBody })));
};
